import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

interface ICtaContext {
    hideNationalCallCenter?: boolean
    hideFranchiseLink?: boolean
    overridePhoneNumber?: string
    overridePhoneNumberDescriptor?: string,
}

const CtaContext = React.createContext<ICtaContext>(null as unknown as ICtaContext);

type CtaProviderProps = {
    children: React.ReactNode | React.ReactNode[] | null | string
} & ICtaContext;

const CtaProvider = ({
    children,
    hideFranchiseLink,
    hideNationalCallCenter,
    overridePhoneNumber,
    overridePhoneNumberDescriptor
}: CtaProviderProps): JSX.Element => {
    const { cmsSiteSettings: siteSetting } = useStaticQuery(
        graphql`
            query siteSetting {
                cmsSiteSettings {
                    out_of_service_mode
                }
            }
        `,
    );

    /*
    * Basically if ServPro HQ is out of action lol,
    * but by some miracle someone updates the CMS
    * */
    const defaultHideNationalCallCenter = siteSetting.out_of_service_mode;

    const value = React.useMemo(() => ({
        hideFranchiseLink,
        hideNationalCallCenter: hideNationalCallCenter || defaultHideNationalCallCenter,
        overridePhoneNumber,
        overridePhoneNumberDescriptor,
    }), [
        defaultHideNationalCallCenter,
        hideFranchiseLink,
        hideNationalCallCenter,
        overridePhoneNumber,
        overridePhoneNumberDescriptor,
    ]);

    return (
        <CtaContext.Provider
            value={value}
        >
            {children}
        </CtaContext.Provider>
    );
};

export default CtaProvider;

export const useCtaProvider = (): ICtaContext => {
    const ctx = React.useContext(CtaContext);
    if (!ctx) {
        throw new Error('No CTA Context has been provided.');
    }
    return ctx;
};
